'use strict';

const GetInTouchPopup = {
    init: function () {
        const ctaPopup = document.getElementById('get-in-touch-popup');
        if (!ctaPopup) return;

        const triggers = document.querySelectorAll('.js-open-get-in-touch');
        if (!triggers.length) return;

        const ctaClose = ctaPopup.querySelector('.get-in-touch__popup__close');
        const ctaPanel = ctaPopup.querySelector('.get-in-touch__popup__panel');

        function setInitialFocus() {
            if (ctaClose) {
                ctaClose.focus({ preventScroll: true });
                return;
            }

            if (ctaPanel) {
                if (!ctaPanel.hasAttribute('tabindex')) {
                    ctaPanel.setAttribute('tabindex', '-1');
                }

                ctaPanel.focus({ preventScroll: true });
                return;
            }

            if (!ctaPopup.hasAttribute('tabindex')) {
                ctaPopup.setAttribute('tabindex', '-1');
            }

            ctaPopup.focus({ preventScroll: true });
        }

        function openPopup(e) {
            e.preventDefault();
            ctaPopup.showModal();
            window.requestAnimationFrame(setInitialFocus);
        }

        function closePopup() {
            ctaPopup.close();
        }

        triggers.forEach(function (trigger) {
            trigger.addEventListener('click', openPopup);
        });

        if (ctaClose) {
            ctaClose.addEventListener('click', closePopup);
        }

        // Close on backdrop click (click outside the panel)
        // Only close if click is directly on the dialog (backdrop), not on panel or its children
        ctaPopup.addEventListener('click', function (e) {
            if (e.target === ctaPopup) {
                closePopup();
            }
        });
    },
};

export default GetInTouchPopup;
